import './photoswipe.scss';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const lightbox = new PhotoSwipeLightbox({
    gallery: '#image-zoom a',
    pswpModule: () => import('photoswipe')
});
lightbox.init();
